// extracted by mini-css-extract-plugin
module.exports = {"header__animation":"Animation_header__animation__2w2Wb","blob1":"Animation_blob1__3UY7v","move":"Animation_move__3MWTB","blob2":"Animation_blob2__1MNKm"};